/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import "../styles/resume.css";
import Marque from "./Marque";
import CodeSnippet from "../images/codesnippet.png";
import ResumeImage from "../images/resume.jpeg";
import MyImage from "../images/myimageround.png";
import { motion, AnimatePresence } from "framer-motion";
import BigText from "./BigText";

import GlowShade from "./GlowShade";

import { useAudio } from "./AudioContext";

export default function Resume() {
  const { playAudio, playBeep, pauseBeep, playWater, pauseWater } = useAudio();

  const handleClick = () => {
    playAudio();
  };

  const handleMouseEnter = () => {
    playBeep();
  };

  const handleMouseLeave = () => {
    pauseBeep();
  };

  const handleWater = () => {
    playWater(0.3);
  };

  const handleWaterLeave = () => {
    pauseWater();
  };

  return (
    <AnimatePresence>
      <div className="resume">
        <Marque text={"Resume"} top="250px" id={"resume"} />
        <BigText text={"Resume"} top="400px" top2="440px" />
        <div>
          <motion.div
            initial={{ rotate: 0, scale: 0.9 }}
            whileInView={{ rotate: -10, scale: 1 }}
            whileHover={{ scale: 0.95, rotate: -8 }}
            transition={{ duration: 0.5 }}
            exit={{ rotate: 0, scale: 0.6 }}
            className="resumesnippet"
            onMouseEnter={handleWater}
            onMouseLeave={handleWaterLeave}
          >
            <img src={ResumeImage} alt="resume" />
          </motion.div>
          <GlowShade
            color="#000000"
            top="120%"
            left="-4%"
            height="200px"
            width="200px"
          />
          <div className="myimage">
            <motion.img
              initial={{ rotate: 0, scale: 0.9 }}
              whileInView={{ rotate: -10, scale: 1 }}
              whileHover={{
                y: -10,
              }}
              transition={{ duration: 0.5 }}
              exit={{ rotate: 0, scale: 0.6 }}
              src={MyImage}
              alt="myimage"
              onMouseEnter={handleWater}
              onMouseLeave={handleWaterLeave}
            />
          </div>
          <motion.div
            initial={{ rotate: 0, scale: 0.9 }}
            whileInView={{ rotate: 5, scale: 1 }}
            transition={{ duration: 1 }}
            whileHover={{ scale: 0.95, rotate: 8 }}
            exit={{ rotate: 0, scale: 0.6 }}
            className="codesnippet"
            onMouseEnter={handleWater}
            onMouseLeave={handleWaterLeave}
          >
            <img src={CodeSnippet} alt="code snippet" />
          </motion.div>

          <div className="btns">
            <button className="btn">
              <a
                href="https://www.canva.com/design/DAF-jren34U/RGQxr4gIThMl3gV6WxTeTw/view?utm_content=DAF-jren34U&utm_campaign=designshare&utm_medium=link&utm_source=editor"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                View Resume
              </a>
            </button>
            <div className="links">
              <a
                href="https://www.linkedin.com/in/cheegitimahesh"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                LinkedIn
              </a>

              <a
                href="https://github.com/Maheshcheegiti"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                Github
              </a>

              <a
                href="https://twitter.com/maheshaaryan24"
                target="_blank"
                rel="noopener noreferrer"
                onClick={handleClick}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                Twitter
              </a>
            </div>
          </div>

          <GlowShade
            color="#00BBFF99"
            top="250%"
            left="80%"
            height="200px"
            width="200px"
          />
        </div>
      </div>
    </AnimatePresence>
  );
}
